import { TargetGroup, TargetGroupEnum } from './types';

export const translateTargetGroup = (targetGroup: TargetGroupEnum | '') => {
  if (targetGroup === '') return '';
  switch (targetGroup) {
    case 'Alumni':
      return 'Alumner';
    case 'Freshmen':
      return 'Nollan';
    case 'Student':
      return 'Studenter';
    case 'All':
      return 'Studenter & Alumner';
    default:
      return '';
  }
};

export function translateTargetGroupNicely(targetGroup: TargetGroup): string {
  const { group, count, divisionName } = targetGroup;
  const countText = count === -1 ? '' : `(${count} st)`;
  if (!group) return '';
  switch (group) {
    case 'Alumni':
      return divisionName
        ? `Alumner på ${divisionName} ${countText}`
        : `Alumner ${countText}`;
    case 'Freshmen':
      return divisionName
        ? `Nollan på ${divisionName} ${countText}`
        : `Nollan ${countText}`;
    case 'Student':
      return divisionName
        ? `Studenter på ${divisionName} ${countText}`
        : `Studenter ${countText}`;
    case 'All':
      return divisionName
        ? `Studenter på ${divisionName} ${countText}`
        : `Studenter ${countText}`;
    default:
      return '';
  }
}
